<template>
   <v-layout wrap align-content-start>
      <v-flex xs12 pa-4 text-center>
         <span class="font-weight-bold text-h4">
            Becas UNICAES
            {{ sede == 'SA' ? 'Santa Ana' : 'ILOBASCO' }} ciclo
            {{ selectCiclo }}
         </span>
      </v-flex>

      <!-- SELECTOR DE CICLO + BOTÓN REPORTES -->
      <v-flex xs12 pa-4 class="d-flex align-center gap-4">
         <v-autocomplete
            v-model="selectCiclo"
            label="Ciclo a mostrar"
            no-data-text="Sin resultados"
            :items="cmbCiclos"
            style="max-width:220px"
         ></v-autocomplete>
         <v-spacer></v-spacer>
         <v-btn
            color="primary"
            depressed
            :loading="loadingReporte"
            @click="generarReporteTablas"
         >
            <v-icon left small>fas fa-file-excel</v-icon>
            Reportes
         </v-btn>
      </v-flex>
      <v-flex xs12 pa-4>
         <span class="font-weight-bold text-h4 colorPrimary">
            <countTo
               :start-val="0"
               :end-val="cantBecadosAprobados"
               :duration="3000"
            ></countTo>
            Becas aprobadas
         </span>
         <br />
         <span class="font-weight-bold text-h5" style="color: #616161">
            <countTo
               :start-val="0"
               :end-val="cantBecadosAprobadosConsejo"
               :duration="3000"
            ></countTo>
            Becas aprobadas por consejo
         </span>
      </v-flex>
      <!-- POR TIPO BENEFICIARIO -->
      <v-flex xs12 sm8 pa-4>
         <v-data-table
            dense
            :mobile-breakpoint="0"
            :headers="headersTipoBeneficario"
            :items="datosTipoBeneficiario"
            item-key="name"
            disable-pagination
            hide-default-footer
            :loading="loadingTipoBeneficiario"
            loading-text="Cargando datos, por favor espere ..."
            no-data-text="Sin datos"
            class="elevation-1 mytable"
         >
            <template #item.monto="{ item }">
               $ {{ numFormatIntl(item.monto) }}
            </template>
            <template #body.append="{}">
               <tr>
                  <td class="font-weight-bold text-subtitle-1">
                     Total general
                  </td>
                  <td
                     style="text-align: right"
                     class="font-weight-bold text-subtitle-1"
                  >
                     $ {{ totalMontoTipoBeneficiario }}
                  </td>
                  <td
                     style="text-align: center"
                     class="font-weight-bold text-subtitle-1"
                  >
                     {{ totalNumBecaTipoBeneficiario }}
                  </td>
               </tr>
            </template>
         </v-data-table>
      </v-flex>
      <!-- BIENESTAR UNIVERSITARIO -->
      <v-flex xs12 sm4 pa-4 class="d-flex flex-column justify-space-between">
         <v-data-table
            dense
            :items="datosBienestar"
            :mobile-breakpoint="0"
            :loading="loadingBienestar"
            :headers="headersBienestar"
            item-key="key"
            disable-pagination
            hide-default-footer
            no-data-text="Sin datos"
            class="elevation-1 mytable"
         >
            <template #item.key="{ item }">
               {{ splitNombreBienestar(item.key) }}
            </template>
            <template #body.append="{}">
               <tr>
                  <td class="font-weight-bold text-subtitle-1">Total</td>
                  <td class="font-weight-bold text-subtitle-1 text-center">
                     {{ totalBienestar }}
                  </td>
               </tr>
            </template>
         </v-data-table>
      </v-flex>
      <v-flex xs12 pa-4>
         <v-card
            :class="{
               'd-flex flex-column align-center justify-center':
                  $vuetify.breakpoint.smAndDown,
               'd-flex flex-row align-center justify-center':
                  $vuetify.breakpoint.mdAndUp
            }"
         >
            <v-layout class="text-h6" align-center justify-center
               >Mostrar datos de tipo de beneficio por:</v-layout
            >
            <v-layout align-center justify-center>
               <span class="text-h6 pr-2">N° de becas</span>
               <v-switch v-model="showMontoTipoBeneficiario" color="primary">
               </v-switch>
               <span class="text-h6 pl-2">Suma total</span>
            </v-layout>
         </v-card>
      </v-flex>
      <v-flex xs12 sm6 pa-4>
         <v-card class="rounded-lg">
            <v-card-title> Becados por tipo de beneficiario </v-card-title>
            <apexchart
               height="350"
               width="100%"
               type="bar"
               :options="chBarTipoBeneficarioOptions"
               :series="chBarTipoBeneficarioSeries"
            ></apexchart>
         </v-card>
      </v-flex>
      <v-flex xs12 sm6 pa-4>
         <v-card class="rounded-lg">
            <v-card-title> Porcentajes por tipo de beneficiario </v-card-title>
            <apexchart
               height="350"
               width="100%"
               type="pie"
               :options="chPieTipoBeneficarioOptions"
               :series="chPieTipoBeneficarioSeries"
            ></apexchart>
         </v-card>
      </v-flex>

      <!-- POR CARRERA -->
      <v-flex xs12 sm12 pa-4>
         <v-data-table
            dense
            :mobile-breakpoint="0"
            :headers="headersCarrera"
            :items="datosCarrera"
            item-key="name"
            fixed-header
            :height="datosCarrera.length > 10 ? '450' : ''"
            disable-pagination
            hide-default-footer
            :loading="loadingCarrera"
            loading-text="Cargando datos, por favor espere ..."
            no-data-text="Sin datos"
            class="elevation-1 mytable"
         >
            <template #item.monto="{ item }">
               $ {{ numFormatIntl(item.monto) }}
            </template>
            <template #body.append="{}">
               <tr>
                  <td class="font-weight-bold text-subtitle-1">
                     Total general
                  </td>
                  <td
                     style="text-align: right"
                     class="font-weight-bold text-subtitle-1"
                  >
                     $ {{ totalMontoCarrera }}
                  </td>
                  <td
                     style="text-align: center"
                     class="font-weight-bold text-subtitle-1"
                  >
                     {{ totalNumBecaCarrera }}
                  </td>
               </tr>
            </template>
         </v-data-table>
      </v-flex>
      <v-flex xs12 sm12 pa-4>
         <v-card>
            <v-card-title>Mostrar datos de carreras por:</v-card-title>
            <v-layout align-center justify-center>
               <span class="text-h6 pr-2">N° de becas</span>
               <v-switch v-model="showMontoCarrera" color="primary"> </v-switch>
               <span class="text-h6 pl-2">Suma total</span>
            </v-layout>
         </v-card>
      </v-flex>
      <v-flex xs12 sm12 pa-4>
         <v-card class="rounded-lg">
            <v-card-title> Becados por carrera </v-card-title>
            <apexchart
               height="400"
               width="100%"
               type="bar"
               :options="chBarCarreraOptions"
               :series="chBarCarreraSeries"
            ></apexchart>
         </v-card>
      </v-flex>
   </v-layout>
</template>

<script>
import axios from 'axios'
import VueApexCharts from 'vue-apexcharts'
import { authComputed } from '../helpers'
import formatters from '../mixins/formattersLib'
import countTo from 'vue-count-to'
import ExcelJS from 'exceljs'

export default {
   name: 'BecasDashboard',
   components: {
      apexchart: VueApexCharts,
      countTo: countTo
   },
   mixins: [formatters],
   data: (vm) => ({
      // Variables
      sede: process.env.VUE_APP_SEDE,
      loadingReporte: false,
      cmbCiclos: [],
      selectCiclo: '',
      datosEstadistica: [],
      // Por tipo beneficiario
      showMontoTipoBeneficiario: true,
      loadingTipoBeneficiario: false,
      loadingBienestar: false,
      totalBienestar: 0,
      headersTipoBeneficario: [
         {
            text: 'Tipo beneficiario',
            value: 'tipoBeneficio',
            class: 'tituloPrimary'
         },
         {
            text: 'Suma total de ciclo',
            value: 'monto',
            align: 'right',
            class: 'tituloPrimary'
         },
         {
            text: 'Total de alumnos',
            value: 'numeroDeBecas',
            class: 'tituloPrimary',
            align: 'center'
         }
      ],
      datosTipoBeneficiario: [],
      chBarTipoBeneficarioOptions: {
         chart: {
            id: 'chBarTipoBeneficario'
         },
         colors: ['#A00402'],
         plotOptions: {
            bar: {
               horizontal: true,
               borderRadius: 2
            }
         },
         dataLabels: {
            enabled: false
         },
         xaxis: {
            categories: [
               // Fill with labels
            ],
            labels: {
               formatter: (value) => {
                  if (!vm.showMontoTipoBeneficiario) {
                     return vm.numFormatIntl(value)
                  } else {
                     return '$' + vm.numFormatIntl(value)
                  }
               }
            }
         },
         yaxis: {
            labels: {
               formatter: (value) => {
                  if (vm.numFormatIntl(value) == 'NaN') {
                     return value
                  } else {
                     if (!vm.showMontoTipoBeneficiario) {
                        return vm.numFormatIntl(value)
                     } else {
                        return '$' + vm.numFormatIntl(value)
                     }
                  }
               }
            }
         }
      },
      chBarTipoBeneficarioSeries: [
         {
            name: '',
            data: [
               // Fill with data
            ]
         }
      ],
      chPieTipoBeneficarioOptions: {
         chart: {
            id: 'chPieTipoBeneficario',
            toolbar: {
               show: true,
               tools: {
                  download: true
               }
            }
         },
         colors: [
            // Theme 1
            '#A00402',
            '#EDAE49',
            '#F9DF74',
            '#F9EDCC',
            '#AEA4BF',
            '#8F6593',
            '#F991CC'

            // Theme 2
            // '#A00402',
            // '#FF5376',
            // '#F8C0C8',
            // '#E2C290',
            // '#735D78',
            // '#283044',
            // '#78A1BB'
         ],
         labels: [
            // Fill with labels
         ]
      },
      chPieTipoBeneficarioSeries: [
         // Fill with data
      ],
      // Por carrera
      showMontoCarrera: true,
      loadingCarrera: false,
      headersCarrera: [
         {
            text: 'Carrera universitaria',
            value: 'carrera',
            class: 'tituloPrimary'
         },
         {
            text: 'Suma total de ciclo',
            value: 'monto',
            align: 'right',
            width: 190,
            class: 'tituloPrimary'
         },
         {
            text: 'Total de alumnos',
            value: 'numeroDeBecas',
            class: 'tituloPrimary',
            align: 'center'
         }
      ],
      headersBienestar: [
         {
            text: 'Tipo',
            value: 'key',
            class: 'tituloPrimary'
         },
         {
            text: 'Becas',
            value: 'val',
            class: 'tituloPrimary',
            align: 'center'
         }
      ],
      datosBienestar: [],
      datosCarrera: [],
      chBarCarreraOptions: {
         chart: {
            id: 'chBarCarrera'
         },
         colors: ['#A00402'],
         plotOptions: {
            bar: {
               borderRadius: 2
            }
         },
         dataLabels: {
            enabled: false
         },
         stroke: {
            width: 2
         },
         yaxis: {
            labels: {
               formatter: (value) => {
                  if (!vm.showMontoCarrera) {
                     return vm.numFormatIntl(value)
                  } else {
                     return '$' + vm.numFormatIntl(value)
                  }
               }
            }
         },
         xaxis: {
            categories: [
               // Fill with labels
            ],
            labels: {
               trim: true,
               hideOverlappingLabels: false
            }
         }
      },
      chBarCarreraSeries: [
         {
            name: '',
            data: [
               // Fill with data
            ]
         }
      ]
   }),
   computed: {
      ...authComputed,
      cantBecadosAprobados() {
         var total = 0
         this.datosEstadistica.forEach((el) => {
            total = Number(total) + Number(el.cantidad)
         })
         return total
      },
      cantBecadosAprobadosConsejo() {
         var total = 0
         this.datosEstadistica.forEach((el) => {
            total = Number(total) + Number(el.aprobadasPorConsejo)
         })
         return total
      },
      totalMontoTipoBeneficiario() {
         var total = 0
         if (this.datosTipoBeneficiario.length > 0) {
            this.datosTipoBeneficiario.forEach((el) => {
               total = Number(total) + Number(el.monto)
            })
         }
         return this.numFormatIntl(total)
      },
      totalNumBecaTipoBeneficiario() {
         var total = 0
         if (this.datosTipoBeneficiario.length > 0) {
            this.datosTipoBeneficiario.forEach((el) => {
               total = Number(total) + Number(el.numeroDeBecas)
            })
         }
         return this.numFormatIntl(total, 0)
      },
      totalMontoCarrera() {
         var total = 0
         if (this.datosCarrera.length > 0) {
            this.datosCarrera.forEach((el) => {
               total = Number(total) + Number(el.monto)
            })
         }
         return this.numFormatIntl(total)
      },
      totalNumBecaCarrera() {
         var total = 0
         if (this.datosCarrera.length > 0) {
            this.datosCarrera.forEach((el) => {
               total = Number(total) + Number(el.numeroDeBecas)
            })
         }
         return this.numFormatIntl(total, 0)
      }
   },
   watch: {
      selectCiclo() {
         this.listarDatos()
      },
      showMontoTipoBeneficiario() {
         // Update data
         this.updateDataTipoBeneficiario(this.datosTipoBeneficiario)
      },
      showMontoCarrera() {
         // Update data
         this.updateDataCarreras(this.datosCarrera)
      },
      datosTipoBeneficiario(val) {
         var newLabels = []
         val.forEach((el) => {
            newLabels.push(el.tipoBeneficio)
         })
         // Update labels
         this.chBarTipoBeneficarioOptions = {
            ...this.chBarTipoBeneficarioOptions,
            ...{
               xaxis: {
                  categories: newLabels
               }
            }
         }
         this.chPieTipoBeneficarioOptions = {
            ...this.chPieTipoBeneficarioOptions,
            ...{
               labels: newLabels
            }
         }

         // Update data
         this.updateDataTipoBeneficiario(val)
      },
      datosCarrera(val) {
         var newLabels = []
         val.forEach((el) => {
            newLabels.push(el.carrera)
         })
         // Update labels
         this.chBarCarreraOptions = {
            ...this.chBarCarreraOptions,
            ...{
               xaxis: {
                  categories: newLabels
               }
            }
         }
         // Update data
         this.updateDataCarreras(val)
      }
   },
   created() {
      //Validando acceso al componente
      if (this.permController(4, 'ver')) {
         this.listarComboboxes()
      } else {
         this.$router.push({ name: 'inicio' })
      }
   },
   methods: {
      updateDataCarreras(val) {
         var newData = []
         val.forEach((el) => {
            if (this.showMontoCarrera) {
               newData.push(Number(el.monto))
            } else {
               newData.push(Number(el.numeroDeBecas))
            }
         })
         this.chBarCarreraSeries = [
            {
               name: '',
               data: newData
            }
         ]
      },
      splitNombreBienestar(nombre) {
         return nombre
            .split(/(?=[A-Z])/)
            .join(' ')
            .replace('numero', '')
      },
      updateDataTipoBeneficiario(val) {
         var newData = []
         val.forEach((el) => {
            if (this.showMontoTipoBeneficiario) {
               newData.push(Number(el.monto))
            } else {
               newData.push(Number(el.numeroDeBecas))
            }
         })
         this.chBarTipoBeneficarioSeries = [
            {
               name: '',
               data: newData
            }
         ]
         this.chPieTipoBeneficarioSeries = newData
      },
      listarComboboxes() {
         axios
            .get('api/SolicitudDeBeca/ciclosDisponibles')
            .then((response) => {
               this.cmbCiclos = response.data
               this.selectCiclo = response.data[response.data.length - 1]
            })
            .catch(() => {
               //console.log(error)
            })
      },
      listarDatos() {
         this.loadingTipoBeneficiario = true
         this.loadingCarrera = true
         this.loadingBienestar = true
         axios
            .get(
               'api/Beca/Reportes/Estadistica?periodoLectivo=' +
                  this.selectCiclo
            )
            .then((response) => {
               this.datosEstadistica = response.data
            })
            .catch((error) => {
               console.log(error)
            })
         axios
            .get(
               '/api/Beca/Reportes/BienestarUniversitario?periodoLectivo=' +
                  this.selectCiclo
            )
            .then((response) => {
               this.datosBienestar = Object.entries(response.data).map(
                  ([key, val]) => ({
                     key,
                     val
                  })
               )
               this.datosBienestar.shift()
               this.totalBienestar = this.datosBienestar.pop().val
            })
            .catch((error) => {
               console.log(error)
            })
            .finally(() => {
               this.loadingBienestar = false
            })

         axios
            .get(
               'api/Beca/Reportes/PorBeneficio?periodoLectivo=' +
                  this.selectCiclo
            )
            .then((response) => {
               this.datosTipoBeneficiario = response.data.filter((tipo) => {
                  return tipo.tipoBeneficioId != 8 && tipo.tipoBeneficioId != 9
               })
            })
            .catch((error) => {
               console.log(error)
            })
            .finally(() => {
               this.loadingTipoBeneficiario = false
            })
         axios
            .get(
               'api/Beca/Reportes/PorCarrera?periodoLectivo=' + this.selectCiclo
            )
            .then((response) => {
               this.datosCarrera = response.data.filter((obj) => {
                  return obj.numeroDeBecas > 0
               })
            })
            .catch((error) => {
               console.log(error)
            })
            .finally(() => {
               this.loadingCarrera = false
            })
      },
      autoFitCols(ws, rows) {
         const colWidths = []
         rows.forEach(row => {
            row.forEach((cell, c) => {
               const len = cell == null ? 0 : String(cell).length
               colWidths[c] = Math.max(colWidths[c] || 0, len)
            })
         })
         ws['!cols'] = colWidths.map(w => ({ wch: Math.min(w + 2, 80) }))
      },
      async generarReporteTablas() {
         this.loadingReporte = true
         const sede  = this.sede == 'SA' ? 'Santa Ana' : 'Ilobasco'
         const ciclo = this.selectCiclo

         // ── Colores ────────────────────────────────────────────
         const C_RESUMEN  = 'FF1F3864' // azul oscuro  — Resumen
         const C_BENEF    = 'FF1E6B3A' // verde oscuro — Por Beneficiario
         const C_BIENESTAR= 'FF7B3F00' // café         — Bienestar
         const C_CARRERA  = 'FF6A0572' // morado       — Por Carrera
         const C_TOTAL    = 'FF2F5597' // azul medio   — filas Total general

         const estiloTitulo = color => ({
            font:      { bold: true, color: { argb: 'FFFFFFFF' }, size: 13 },
            fill:      { type: 'pattern', pattern: 'solid', fgColor: { argb: color } },
            alignment: { vertical: 'middle', horizontal: 'center' }
         })
         const estiloHeader = {
            font:      { bold: true, color: { argb: 'FFFFFFFF' }, size: 10 },
            fill:      { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF2F5597' } },
            alignment: { vertical: 'middle', horizontal: 'center' },
            border:    { bottom: { style: 'thin', color: { argb: 'FF1F3864' } } }
         }
         const estiloFila = par => ({
            fill:      { type: 'pattern', pattern: 'solid', fgColor: { argb: par ? 'FFFFFFFF' : 'FFF0F4FA' } },
            font:      { size: 10 },
            alignment: { vertical: 'middle' }
         })
         const estiloTotal = {
            font:      { bold: true, color: { argb: 'FFFFFFFF' }, size: 10 },
            fill:      { type: 'pattern', pattern: 'solid', fgColor: { argb: C_TOTAL } },
            alignment: { vertical: 'middle', horizontal: 'center' }
         }

         const addTitulo = (ws, texto, color, ncols) => {
            const row = ws.addRow([texto])
            row.height = 24
            ws.mergeCells(`A${row.number}:${String.fromCharCode(64 + ncols)}${row.number}`)
            row.getCell('A').style = estiloTitulo(color)
            // Auto-ajustar: si el título no cabe en el ancho total de las columnas fusionadas, expandir col A
            const anchoTotal = Array.from({ length: ncols }, (_, i) => ws.getColumn(i + 1).width || 10).reduce((a, b) => a + b, 0)
            const anchoNecesario = Math.ceil(texto.length * 1.15)
            if (anchoNecesario > anchoTotal) {
               ws.getColumn(1).width = anchoNecesario - Array.from({ length: ncols - 1 }, (_, i) => ws.getColumn(i + 2).width || 10).reduce((a, b) => a + b, 0)
            }
            return row
         }
         const addHeaders = (ws, headers) => {
            const row = ws.addRow(headers)
            row.height = 18
            row.eachCell(cell => { cell.style = estiloHeader })
            return row
         }
         const addTotal = (ws, valores) => {
            const row = ws.addRow(valores)
            row.height = 18
            row.eachCell(cell => { cell.style = estiloTotal })
            return row
         }

         const wb = new ExcelJS.Workbook()
         wb.creator = 'Colecturía Digital'
         wb.created = new Date()

         // ── Hoja 1: Resumen general ────────────────────────────
         const wsResumen = wb.addWorksheet('Resumen')
         wsResumen.columns = [{ width: 32 }, { width: 18 }]

         addTitulo(wsResumen, `Reporte de Becas UNICAES ${sede} — Ciclo ${ciclo}`, C_RESUMEN, 2)

         const kpis = [
            ['Becas aprobadas',        this.cantBecadosAprobados],
            ['Aprobadas por consejo',  this.cantBecadosAprobadosConsejo],
         ]
         kpis.forEach(([label, val], i) => {
            const r = wsResumen.addRow([label, val])
            r.eachCell(cell => { cell.style = estiloFila(i % 2 === 0) })
         })

         // ── Hoja 2: Por tipo de beneficiario ──────────────────
         const wsBenef = wb.addWorksheet('Por Beneficiario')
         wsBenef.columns = [{ width: 30 }, { width: 18 }, { width: 14 }]

         addTitulo(wsBenef, `Por tipo de beneficiario — ${ciclo}`, C_BENEF, 3)
         addHeaders(wsBenef, ['Tipo de beneficiario', 'Suma total', 'N° alumnos'])

         this.datosTipoBeneficiario.forEach((r, i) => {
            const st  = estiloFila(i % 2 === 0)
            const row = wsBenef.addRow([r.tipoBeneficio, Number(r.monto), Number(r.numeroDeBecas)])
            row.getCell(1).style = st
            row.getCell(2).style = { ...st, numFmt: '"$"#,##0.00' }
            row.getCell(3).style = { ...st, numFmt: '0' }
         })
         const wsBenefTotal = addTotal(wsBenef, [
            'Total general',
            Number(this.datosTipoBeneficiario.reduce((a, r) => a + Number(r.monto), 0)),
            Number(this.datosTipoBeneficiario.reduce((a, r) => a + Number(r.numeroDeBecas), 0))
         ])
         wsBenefTotal.getCell(2).style = { ...estiloTotal, numFmt: '"$"#,##0.00' }
         wsBenefTotal.getCell(3).style = { ...estiloTotal, numFmt: '0' }

         // ── Hoja 3: Bienestar universitario ───────────────────
         const wsBienestar = wb.addWorksheet('Bienestar')
         wsBienestar.columns = [{ width: 36 }, { width: 14 }]

         addTitulo(wsBienestar, `Bienestar universitario — ${ciclo}`, C_BIENESTAR, 2)
         addHeaders(wsBienestar, ['Tipo', 'N° becas'])

         this.datosBienestar.forEach((r, i) => {
            const st  = estiloFila(i % 2 === 0)
            const row = wsBienestar.addRow([this.splitNombreBienestar(r.key), Number(r.val)])
            row.getCell(1).style = st
            row.getCell(2).style = { ...st, numFmt: '0' }
         })
         const wsBienestarTotal = addTotal(wsBienestar, ['Total (Bienestar Universitario + Servicio Estudiantil)', this.totalBienestar])
         wsBienestarTotal.getCell(2).style = { ...estiloTotal, numFmt: '0' }

         // ── Hoja 4: Por carrera ────────────────────────────────
         const wsCarrera = wb.addWorksheet('Por Carrera')
         wsCarrera.columns = [{ width: 50 }, { width: 18 }, { width: 14 }]

         addTitulo(wsCarrera, `Por carrera universitaria — ${ciclo}`, C_CARRERA, 3)
         addHeaders(wsCarrera, ['Carrera universitaria (No incluye auspiciados)','Monto por carrera $', 'N° alumnos'])

         this.datosCarrera.forEach((r, i) => {
            const st  = estiloFila(i % 2 === 0)
            const row = wsCarrera.addRow([r.carrera, Number(r.monto), Number(r.numeroDeBecas)])
            row.getCell(1).style = st
            row.getCell(2).style = { ...st, numFmt: '"$"#,##0.00' }
            row.getCell(3).style = { ...st, numFmt: '0' }
         })
         const wsCarreraTotal = addTotal(wsCarrera, [
            'Total general',
            Number(this.datosCarrera.reduce((a, r) => a + Number(r.monto), 0)),
            Number(this.datosCarrera.reduce((a, r) => a + Number(r.numeroDeBecas), 0))
         ])
         wsCarreraTotal.getCell(2).style = { ...estiloTotal, numFmt: '"$"#,##0.00' }
         wsCarreraTotal.getCell(3).style = { ...estiloTotal, numFmt: '0' }

         // ── Hoja 5: Detalle de becados por carrera ────────────
         const C_CARRERA_HDR = 'FF4A235A' // morado oscuro — subencabezado carrera
         const C_SUBTOTAL    = 'FF6A0572' // morado medio  — fila subtotal por carrera

         const estiloSubtitulo = {
            font:      { bold: true, color: { argb: 'FFFFFFFF' }, size: 11 },
            fill:      { type: 'pattern', pattern: 'solid', fgColor: { argb: C_CARRERA_HDR } },
            alignment: { vertical: 'middle', horizontal: 'left' }
         }
         const estiloSubtotal = {
            font:      { bold: true, color: { argb: 'FFFFFFFF' }, size: 10 },
            fill:      { type: 'pattern', pattern: 'solid', fgColor: { argb: C_SUBTOTAL } },
            alignment: { vertical: 'middle', horizontal: 'center' }
         }

         let detallePorCarrera = []
         try {
            const res = await axios.get(`api/Beca/Reportes/DetallePorCarrera?periodoLectivo=${ciclo}`)
            detallePorCarrera = res.data
         } catch (_) { /* si falla la hoja queda vacía */ }

         const wsDetalle = wb.addWorksheet('Detalle por Carrera')
         wsDetalle.columns = [{ width: 16 }, { width: 40 }, { width: 16 }, { width: 18 }]

         addTitulo(wsDetalle, `Detalle de becados por carrera — ${ciclo}`, C_CARRERA_HDR, 4)

         let granTotal = 0
         for (const grupo of detallePorCarrera) {
            // Fila de nombre de carrera
            const filaCarrera = wsDetalle.addRow([grupo.carrera])
            filaCarrera.height = 18
            wsDetalle.mergeCells(`A${filaCarrera.number}:D${filaCarrera.number}`)
            filaCarrera.getCell('A').style = estiloSubtitulo

            // Headers de columnas
            addHeaders(wsDetalle, ['Carnet', 'Nombre completo', '% Beca', 'Monto a becar ($)'])

            // Filas de alumnos
            grupo.alumnos.forEach((a, i) => {
               const st  = estiloFila(i % 2 === 0)
               const stR = { ...st, alignment: { ...st.alignment, horizontal: 'right' } }
               const row = wsDetalle.addRow([
                  a.carnet,
                  a.nombreCompleto,
                  Number(a.porcentajeBeca),
                  Number(a.montoBecar)
               ])
               row.getCell(1).style = st
               row.getCell(2).style = st
               row.getCell(3).style = { ...stR, numFmt: '0.00"%"' }
               row.getCell(4).style = { ...stR, numFmt: '"$"#,##0.00' }
            })

            // Subtotal por carrera
            const filaSubtotal = wsDetalle.addRow(['', 'Total carrera', '', Number(grupo.totalMonto)])
            filaSubtotal.height = 18
            filaSubtotal.getCell(1).style = estiloSubtotal
            filaSubtotal.getCell(2).style = estiloSubtotal
            filaSubtotal.getCell(3).style = estiloSubtotal
            filaSubtotal.getCell(4).style = { ...estiloSubtotal, numFmt: '"$"#,##0.00' }

            granTotal += Number(grupo.totalMonto)
            wsDetalle.addRow([]) // línea en blanco entre carreras
         }

         // Gran total final
         const wsDetalleTotalFinal = addTotal(wsDetalle, ['', 'TOTAL GENERAL', '', granTotal])
         wsDetalleTotalFinal.getCell(4).style = { ...estiloTotal, numFmt: '"$"#,##0.00' }

         // ── Hoja 6: Desglose de montos por arancel (tabla plana) ─
         const C_DESGLOSE = 'FF1A5276'

         const wsDesglose = wb.addWorksheet('Desglose de Montos')
         wsDesglose.columns = [
            { width: 16 }, // Carnet
            { width: 36 }, // Nombre
            { width: 34 }, // Carrera
            { width: 22 }, // Beneficiario
            { width: 12 }, // Artículo
            { width: 34 }, // Descripción
            { width: 14 }, // Tipo cobro
            { width: 16 }, // Precio unit.
            { width: 10 }, // % Desc.
            { width: 10 }, // Cuotas
            { width: 18 }, // Monto becado
            { width: 18 }  // Monto a pagar
         ]

         addTitulo(wsDesglose, `Desglose de montos por arancel — ${ciclo}`, C_DESGLOSE, 12)
         addHeaders(wsDesglose, [
            'Carnet', 'Nombre completo', 'Carrera', 'Beneficiario',
            'Cod. Arancel', 'Descripción', 'Tipo cobro',
            'Arancel por Cuota', '% Desc.', 'Cuotas',
            'Monto Total becado ($)', 'Monto a pagar por cuota ($)'
         ])

         const estiloAuspiciado = par => ({
            fill:      { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFB3E5FC' } },
            font:      { size: 10 },
            alignment: { vertical: 'middle' }
         })

         let rowIndex = 0
         for (const grupo of detallePorCarrera) {
            for (const alumno of grupo.alumnos) {
               if (!alumno.desglose || !alumno.desglose.length) continue
               const esAuspiciado = alumno.tipoBeneficiario && alumno.tipoBeneficiario.toLowerCase().includes('auspiciado')
               for (const d of alumno.desglose) {
                  const montoBecado = Number(d.subtotal)
                  const montoPagar  = Number(d.precioUnitario) * (1 - Number(d.descuento) / 100)
                  const row = wsDesglose.addRow([
                     alumno.carnet,
                     alumno.nombreCompleto,
                     grupo.carrera,
                     alumno.tipoBeneficiario || '—',
                     d.articulo,
                     d.descripcion,
                     d.tipoCobro,
                     Number(d.precioUnitario),
                     Number(d.descuento),
                     Number(d.cuotas),
                     montoBecado,
                     montoPagar
                  ])
                  const estilo = esAuspiciado ? estiloAuspiciado() : estiloFila(rowIndex % 2 === 0)
                  const estiloR = { ...estilo, alignment: { ...estilo.alignment, horizontal: 'right' } }
                  row.getCell(1).style  = estilo
                  row.getCell(2).style  = estilo
                  row.getCell(3).style  = estilo
                  row.getCell(4).style  = estilo
                  row.getCell(5).style  = estilo
                  row.getCell(6).style  = estilo
                  row.getCell(7).style  = estilo
                  row.getCell(8).style  = { ...estiloR, numFmt: '"$"#,##0.00' }
                  row.getCell(9).style  = { ...estiloR, numFmt: '0"%"' }
                  row.getCell(10).style = { ...estiloR, numFmt: '0' }
                  row.getCell(11).style = { ...estiloR, numFmt: '"$"#,##0.00' }
                  row.getCell(12).style = { ...estiloR, numFmt: '"$"#,##0.00' }
                  rowIndex++
               }
            }
         }

         // ── Descargar ──────────────────────────────────────────
         const buffer = await wb.xlsx.writeBuffer()
         const blob   = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
         const url    = URL.createObjectURL(blob)
         const a      = document.createElement('a')
         a.href = url
         a.download = `Reporte_Becas_Aprobadas_${sede}_${ciclo}.xlsx`
         a.click()
         URL.revokeObjectURL(url)

         this.loadingReporte = false
      },
   }
}
</script>
